var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h3',[_vm._v("If you need joint the meeting please click in Join Meeting")]),_c('button',{staticClass:"button-signature",on:{"click":_vm.getSignature}},[_vm._v("Join Meeting")])])}
var staticRenderFns = []

export { render, staticRenderFns }